// frontend/src/app/faq/page.tsx
'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';

function FaqSection({ title, items }: { title: string; items: { q: string; a: string }[] }) {
  return (
    <section>
      <h2 className="text-lg font-semibold text-[#1a2e1f] mb-4">{title}</h2>
      <div className="flex flex-col gap-5">
        {items.map((item, i) => (
          <div key={i} className="border-b border-[#e8f0e8] pb-5 last:border-0">
            <p className="font-medium text-[#1a2e1f] mb-1">{item.q}</p>
            <p className="text-[#4a6b57]">{item.a}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default function FaqPage() {
  const t = useTranslations('faq');

  const buyerFaqs = [
    { q: t('bq1'), a: t('ba1') },
    { q: t('bq2'), a: t('ba2') },
    { q: t('bq3'), a: t('ba3') },
    { q: t('bq4'), a: t('ba4') },
    { q: t('bq5'), a: t('ba5') },
    { q: t('bq6'), a: t('ba6') },
  ];

  const sellerFaqs = [
    { q: t('sq1'), a: t('sa1') },
    { q: t('sq2'), a: t('sa2') },
    { q: t('sq3'), a: t('sa3') },
    { q: t('sq4'), a: t('sa4') },
    { q: t('sq5'), a: t('sa5') },
    { q: t('sq6'), a: t('sa6') },
  ];

  return (
    <main className="max-w-2xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-[#1a2e1f] mb-2">{t('title')}</h1>
      <p className="text-[#6b8c7a] mb-10">{t('subtitle')}</p>

      <div className="flex flex-col gap-10 text-sm leading-relaxed">
        <FaqSection title={t('buyersTitle')} items={buyerFaqs} />
        <FaqSection title={t('sellersTitle')} items={sellerFaqs} />
      </div>

      <div className="mt-10 bg-[#f0faf4] border border-[#c8e6c9] rounded-xl p-5 text-sm text-[#4a6b57]">
        <p className="font-medium text-[#1a2e1f] mb-1">{t('stillHaveQuestions')}</p>
        <p>
          <Link href="/contact/" className="text-[#2d7a4f] underline hover:text-[#1a5c36]">
            {t('sendUsMessage')}
          </Link>{' '}
          {t('stillHaveQuestionsDesc')}
        </p>
      </div>
    </main>
  );
}
